import { render, staticRenderFns } from "./bulkregister.vue?vue&type=template&id=088e9c42&scoped=true"
import script from "./bulkregister.vue?vue&type=script&lang=js"
export * from "./bulkregister.vue?vue&type=script&lang=js"
import style0 from "./bulkregister.vue?vue&type=style&index=0&id=088e9c42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e9c42",
  null
  
)

export default component.exports